import React, { useEffect, useState } from 'react'
import TableEditorPreview, { ITableFormat } from 'blocks.app/tableEditor/_preview/tableEditor_preview'
import LoaderBlock from 'blocks.app/loader/_block/loader_block'
import { api } from 'core/api/ConnectionManager'
import { CellModel } from 'core/helpers/_files'
import styles from './preview__table.jcss'

interface IPreviewTableProps {
    item: {
        id: number
    }
}

interface ITableFileData {
    cells: CellModel[][]
    tableFormat: ITableFormat
}

interface IGetTableFileResponse {
    data: ITableFileData
}

const doNothing = () => {}

const PreviewTable = (p_: IPreviewTableProps) => {
    const [tableData, setTableData] = useState<ITableFileData | null>(null)

    useEffect(() => {
        let timer: number | undefined
        let cancelled = false

        api.send<{ id: number }, IGetTableFileResponse>('getFile', { id: p_.item.id }).then(({ data }) => {
            if (cancelled) return

            timer = window.setTimeout(() => {
                setTableData(data)
            }, 300)
        })

        return () => {
            cancelled = true
            if (timer !== undefined) {
                window.clearTimeout(timer)
            }
        }
    }, [p_.item.id])

    return (
        <>
            {!tableData && <LoaderBlock className={styles.loader} />}
            {tableData && (
                <TableEditorPreview
                    wrapperClassName={styles.wrapper}
                    inheritBorder={false}
                    cells={tableData.cells}
                    tableFormat={tableData.tableFormat}
                    onMultiSelectCells={doNothing}
                    onMultiSelectCell={doNothing}
                    onSelectCell={doNothing}
                    selectedCellRow={-1}
                    selectedCellCol={-1}
                    multiSelect={{}}
                />
            )}
        </>
    )
}

export default PreviewTable
